/* ============================================================
   Pholoh "headroom" header — collection + product pages.
   Scroll DOWN -> the header slides up out of view.
   Scroll UP   -> it slides back in.
   The announcement bar is pinned separately and never moves, so it
   stays visible at all times. This only toggles body.pholoh-head--hidden;
   all the motion lives in pholoh-custom.css.
   ============================================================ */
(function () {
  'use strict';

  var HIDE_AFTER = 90; // keep the header shown until scrolled past this (~announcement + header)
  var DELTA = 6;       // ignore sub-pixel / jitter scrolls
  var body = document.body;
  var lastY = window.scrollY || window.pageYOffset || 0;
  var ticking = false;

  function update() {
    ticking = false;
    var y = window.scrollY || window.pageYOffset || 0;

    // Never hide while the nav drawer is open (the header carries the X close)
    // or while near the very top of the page.
    if (document.documentElement.classList.contains('nav-open') || y <= HIDE_AFTER) {
      body.classList.remove('pholoh-head--hidden');
      lastY = y;
      return;
    }

    if (Math.abs(y - lastY) < DELTA) return; // jitter

    if (y > lastY) {
      body.classList.add('pholoh-head--hidden');    // scrolling down -> hide
    } else {
      body.classList.remove('pholoh-head--hidden'); // scrolling up -> reveal
    }
    lastY = y;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
})();
